import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { dataInsights } from './data-insight.actions';
import { SurveyState } from '../../study-survey/store';



@Injectable({providedIn: 'root'})
export class DataInsightFacade {

    constructor(private store: Store<SurveyState>) {}

    dataInsightLoad(userID?:any): void {
        this.store.dispatch(dataInsights({userID}));
      }
}